import { RouteSegment } from '../interfaces/router-map.interface';
import { buildUrl, urlPath } from './router-map.utils';

/**
 * The AccountRouterMap namespace contains routes related to user accounts.
 * @namespace AccountRouterMap
 */
export namespace AccountRouterMap {
  /** The root path for user accounts. */
  export const Root: RouteSegment = 'account';
  /** The profile route. */
  export const Profile: RouteSegment = 'profile';
  /** The bookings route (old). */
  export const MyBookings: RouteSegment = 'bookings';

  export const MyMembership: RouteSegment = 'my-membership';

  /**
   * Generates the URL for account-related routes based on the provided route segments.
   * @param routes An array of route segments.
   *
   * @example
   * const result = AccountRouterMap.url(['foo', 'bar'])
   * // result -> /account/foo/bar
   */
  export const url = (routes: RouteSegment[]) => urlPath('/' + Root, routes);

  /**
   * Generates the account-related route path based on the provided route segments.
   * @param routes An array of route segments.
   *
   * @example
   * const result = AccountRouterMap.buildRoute(['bookings'])
   * // result -> account/bookings (NOTE: without the leading forward slash)
   */
  export const buildRoute = (routes: RouteSegment[]) => urlPath(Root, routes);

  /**
   * Generates the account-related URL based on the provided route segments.
   * Useful for children routes
   * @param routes An array of route segments.
   *
   * @example
   * const result = AccountRouterMap.buildAccountUrl('mobile', ['language'])
   * // result -> /account/mobile/language
   */
  const buildAccountUrl = (root: RouteSegment, routes: RouteSegment[]) => buildUrl(AccountRouterMap.Root, root, routes);
  // const buildAccountUrl = (root: RouteSegment, routes: RouteSegment[]) =>
  //   urlPath('/' + AccountRouterMap.Root + '/' + root, routes);

  /**
   * The Mobile namespace contains routes related to mobile devices within user accounts.
   * @namespace Mobile
   * @memberof RouterMap.Account
   */
  export namespace Mobile {
    /** The root path for mobile-related routes. */
    export const Root: RouteSegment = 'mobile';
    /** The language route. */
    export const Language: RouteSegment = 'language';
    /** The Help and FAQs route. */
    export const HelpAndFAQs: RouteSegment = 'help-and-faqs';

    /**
     * Generates the URL for mobile-related routes based on the provided route segments.
     * @param routes An array of route segments.
     *
     * @example
     * const result = AccountRouterMap.Mobile.url(['foo', 'bar'])
     * // result -> /account/mobile/foo/bar
     */
    export const url = (routes: RouteSegment[]) => buildAccountUrl(Root, routes);
  }
}
